
































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Vue,
  namespace,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import { Route } from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import {
  mdiChartBoxOutline,
  mdiChartBoxPlusOutline,
  mdiClose,
  mdiHeart,
  mdiHeartOutline,
  mdiInformationOutline,
  mdiGiftOutline,
  mdiCheckCircleOutline,
  mdiContentCopy,
} from '@mdi/js'
import LazyHydrate from 'vue-lazy-hydration'
import { Clipboard } from '@capacitor/clipboard'
import { VPopover } from 'v-tooltip'
import debounce from 'lodash/debounce'
import { NotificationOptions } from 'vue-notification'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import {
  IBreadcrumbsItem,
  ISeoFiltersItem,
} from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import {
  InterfaceProductsBlock,
  IParamBlock,
  IParamItem,
  IProduct,
  IProductAdditionalService,
  IProductAspectsItem,
  IProductAspectsVariant,
  IProductDocumentsItem,
  IProductSizeChart,
  IProductToCart,
  IProductToCompare,
  IProductToFavourites,
  IProductBrand,
  IProductsRaw,
} from '~/assets/interfaces/products'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { ICompareItem } from '~/assets/interfaces/compare'
import { IImageVariants } from '~/assets/interfaces/images'
import { IReview } from '~/assets/interfaces/reviews'
import '~/assets/scss/v-tooltip.scss'
import { ICollectionProductsBlock } from '~/assets/interfaces/collection'
import { filterUrl } from '~/assets/filters/url'
import { filterBonus } from '~/assets/filters/bonus'
import { IBonus } from '~/assets/interfaces/bonus'
import MixinGeneral from '~/assets/mixins/general'
import { IPriceItem } from '~/assets/interfaces/price'
import { COMPARE_PATH } from '~/assets/config/path'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import ComponentPageProductsIdSectionMenu from '~/components/pages/products/id/page-products-id-section-menu.vue'
import ComponentSeoFilters from '~/components/navigation/seo-filters.vue'
import ComponentBrand from '~/components/brand/brand.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentRating from '~/components/rating/rating.vue'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentImageGallery from '~/components/images/gallery.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentDelivery from '~/components/delivery/delivery.vue'
import ComponentReviewsPhotos from '~/components/reviews/photos-reviews.vue'
import ComponentMobileReviewsPhotos from '~/components/mobile/reviews/m-photos-reviews.vue'
import ComponentMobileImageGallery from '~/components/mobile/images/m-gallery.vue'
import ComponentProductDescription from '~/components/products/description.vue'
import ComponentProductParams from '~/components/products/params.vue'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentProductItem1 from '~/components/products/product-item-1.vue'
import ComponentProductItem2 from '~/components/products/product-item-2.vue'
import ComponentProductSet from '~/components/products/product-set.vue'
import ComponentProductSetMobile from '~/components/products/product-set-mobile.vue'
import ComponentProductDocuments from '~/components/products/documents.vue'
import ComponentProductAspectsFull from '~/components/products/product-aspects-full.vue'
import ComponentProductScripts from '~/components/products/product-scripts.vue'
import ComponentProductDetailPrices from '~/components/products/product-detail-prices.vue'
import ComponentProductCredits from '~/components/products/product-credits.vue'
import ComponentProductAdditionalServices from '~/components/products/product-additional-services.vue'
import ComponentProductPackaging from '~/components/products/product-packaging.vue'
import ComponentProductFeature from '~/components/products/product-feature.vue'
import ComponentHidingWrapper from '~/components/wrapper/hiding-wrapper.vue'
import ComponentProductAdditionalWrapper from '~/components/products/product-additional-wrapper.vue'
import ComponentProductAvailabilityStoresMap from '~/components/products/product-availability-stores-map.vue'
import ComponentProductAvailable from '~/components/products/product-available.vue'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'
import ComponentProductAvailabilityStores from '~/components/products/product-availability-stores.vue'
import ComponentProductShareButton from '~/components/products/share-button.vue'

Vue.use(VueScrollTo)

interface IProductDescriptionRaw {
  title: string
  text: string
}

interface IProductParamsRaw {
  title: string
  full?: IParamBlock[]
  short?: IParamItem[]
}

interface IProductDocumentsRaw {
  title: string
  items: IProductDocumentsItem[]
}

interface ISectionBlock {
  title: string
  code: string
}

interface ISeoLinksRaw {
  title: string
  items: ISeoFiltersItem[]
}

const pageStore = namespace('page')
const compareStore = namespace('compare')
const favouritesStore = namespace('favourites')
const siteStore = namespace('site')
const catalogStore = namespace('catalog')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    LazyHydrate,
    VPopover,
    ComponentProductAvailabilityStores,
    ComponentProductAvailabilityStoresMap,
    ComponentProductAvailable,
    ComponentProductBuyButton,
    ComponentIntersect,
    ComponentPageContent,
    ComponentNavigationBreadcrumbs,
    ComponentCatalogLabels,
    ComponentRating,
    ComponentIcon,
    ComponentTypographyH1,
    ComponentImageGallery,
    ComponentImage,
    ComponentFormButton,
    ComponentFormButtonIcon,
    ComponentDelivery,
    ComponentReviewsPhotos,
    ComponentMobileReviewsPhotos,
    ComponentMobileImageGallery,
    ComponentProductDescription,
    ComponentProductParams,
    ComponentHeaderWithLink,
    ComponentProductItem1,
    ComponentProductItem2,
    ComponentProductSet,
    ComponentProductSetMobile,
    ComponentProductDocuments,
    ComponentProductAspectsFull,
    ComponentProductScripts,
    ComponentProductDetailPrices,
    ComponentProductCredits,
    ComponentProductAdditionalServices,
    ComponentProductPackaging,
    ComponentProductFeature,
    ComponentHidingWrapper,
    ComponentProductShareButton,
    ComponentSeoFilters,
    ComponentProductAdditionalWrapper,
    ComponentPageProductsIdSectionMenu,
    ComponentBrand,
    ComponentProductsParamsShort: () =>
      import('~/components/products/params-short.vue'),
    ComponentReviews: () => import('~/components/reviews/reviews.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentOrderBuyOneClick: () =>
      import('~/components/products/buy-one-click.vue'),
    ComponentReportArrival: () =>
      import('~/components/products/report-arrival.vue'),
  },
  filters: {
    filterUrl,
    filterBonus,
  },
})
export default class pageCatalogSection extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(PRODUCTS_API + '/' + route.params._id)
      return response
    } catch (err: any) {
      const statusCode =
        err && err.response && err.response.status
          ? (err.response.status as number)
          : 400
      switch (statusCode) {
        case 400:
          error({ statusCode: 400, message: 'Bad Request' })
          break
        case 403:
          error({ statusCode: 403, message: 'Forbidden' })
          break
        case 404:
          error({ statusCode: 404, message: 'Post not found' })
          break
        case 500:
          error({ statusCode: 500, message: 'Internal Server Error' })
          break
        case 502:
          error({ statusCode: 502, message: 'Bad Gateway' })
          break
        default:
          error({ statusCode: 400, message: 'Bad Request' })
          break
      }
    }
  }

  @siteStore.Getter('getLayoutHeaderMobileNumber')
  readonly layoutHeaderMobileNumber!: number | null

  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @compareStore.Action('toCompare') private toCompareAction!: (
    product: IProductToCompare
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]
  @compareStore.State('items') private compareItems!: ICompareItem[]

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  @siteStore.State('origin') private origin!: string
  @siteStore.Getter('getOptionsCurrencyCode')
  private getOptionsCurrencyCode!: string

  @siteStore.Getter('getOptionsProductInStockViewType')
  private productInStockViewType!: string

  @catalogStore.State('backFromProductName')
  readonly backFromProductName!: string | null

  @catalogStore.State('backFromCatalogName')
  readonly backFromCatalogName!: string | null

  @catalogStore.Mutation('setBackFromProductName')
  private setBackFromProductName!: (val: string | null) => void

  @catalogStore.Mutation('setBackFromCatalogName')
  private setBackFromCatalogName!: (val: string | null) => void

  @catalogStore.Mutation('setProducts')
  private catalogSetProduct!: (val: IProductsRaw | null) => void

  @siteStore.Getter('getLayoutHeaderNumber') readonly layoutHeaderNumber!:
    | number
    | null

  private fixedHeaderNumbers = [5, 6, 8, 9, 10, 11, 12]

  @Watch('isPhotoPopup')
  private isPhotoPopupHandler(val: boolean) {
    if (process.client) {
      if (val) {
        window.addEventListener('keyup', this.onEscapeKeyUp)
      } else {
        window.removeEventListener('keyup', this.onEscapeKeyUp)
      }
    }
  }

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private id: number = 0
  private inStock: boolean = false
  private sizeChart: null | IProductSizeChart = null
  private isShowSizeChart = false
  private isShowBuyOneClick = false
  private isCanBuyOneClick = false
  private isShowReportArrivalProduct = false
  private unit: string | null = null
  private multiplicity = 1
  private collection: ICollectionProductsBlock | null = null
  private bonus: IBonus | null = null
  private documents: IProductDocumentsRaw | null = null
  private set: null | { items: IProduct[] } = null
  private ratio: string = '1 / 1'
  private isShowAvailabilityStores = false
  private availableQuantity: null | number = null
  private availableDate: null | string = null
  private canUploadPhoto = false
  private hasVideo = false
  private additionalServices: IProductAdditionalService[] = []
  private additionalServicesForBuy: IProductAdditionalService[] = []
  private description: IProductDescriptionRaw | null = null
  private params: IProductParamsRaw | null = null
  private seoLinks: ISeoLinksRaw | null = null
  private countryBuildName: string = ''
  private countryBuildImg: string = ''

  private isHideAvailabilityStores: boolean = false

  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  private onClickReportArrivalProduct() {
    this.isShowReportArrivalProduct = true
    analyticsReachGoal('goal_receipt_of_goods_begin')
  }

  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => {
      return item.id === this.id
    })
  }

  private get isInCompare() {
    return !!this.compareItems.find((item) => {
      return item.id === this.id
    })
  }

  private get toFavouritesText() {
    return this.isInFavourites ? 'Удалить из избранного' : 'В избранное'
  }

  private get toCompareText() {
    return this.isInCompare ? 'Перейти в сравнение' : 'Сравнить'
  }

  private get classToFavourites() {
    return {
      [this.$style.topLineLinkIconWrapper]: true,
      [this.$style.topLineLeftItem]: true,
      [this.$style.active]: this.isInFavourites,
    }
  }

  private get classToCompare() {
    return {
      [this.$style.topLineLinkIconWrapper]: true,
      [this.$style.topLineLeftItem]: true,
      [this.$style.active]: this.isInCompare,
    }
  }

  private get classToCompareMobile() {
    return {
      [this.$style.topLineLinkIconWrapper]: true,
      [this.$style.topLineLeftItem]: true,
      [this.$style.active]: this.isInCompare,
    }
  }

  private get urlToShare() {
    if (process.client) {
      return this.origin + this.$route.path
    } else {
      return ''
    }
  }

  private getImageToShare() {
    if (this.images.length === 0) {
      return ''
    }

    if (!Object.keys(this.images[0]).includes('small')) {
      return ''
    }

    const image = this.images[0].small
    if (typeof image === 'string') {
      return image
    } else {
      return Object.values(image)[0] as string
    }
  }

  private icons = {
    mdiHeartOutline,
    mdiHeart,
    mdiChartBoxPlusOutline,
    mdiChartBoxOutline,
    mdiClose,
    mdiInformationOutline,
    mdiGiftOutline,
    mdiCheckCircleOutline,
    mdiContentCopy,
  }

  private images: IImageVariants[] = []

  private get photosArray() {
    return this.images.map((image: IImageVariants) => {
      return {
        small: image.small,
        medium: image.medium,
        large: image.large,
        lazyLoad: image.lazyLoad,
        isUserPhoto: image.isUserPhoto,
        meta: image.meta,
      }
    })
  }

  private get photosMobileArray() {
    return this.images.map((image: IImageVariants) => {
      return {
        image: image.medium,
        lazyLoad: image.lazyLoad,
        isUserPhoto: image.isUserPhoto,
        meta: image.meta,
      }
    })
  }

  private articleIsCopied = false

  private get copyLinkIcon() {
    return this.articleIsCopied
      ? this.icons.mdiCheckCircleOutline
      : this.icons.mdiContentCopy
  }

  private async copyArticle() {
    if (!this.articleIsCopied) {
      if (this.isNativePlatform) {
        await Clipboard.write({ string: this.vendorCode })
      } else {
        await navigator.clipboard.writeText(this.vendorCode)
      }

      this.articleIsCopied = true

      Vue.notify({
        group: 'default',
        type: 'info',
        title: 'Скопировано',
        text: 'Артикул успешно скопирован',
        duration: 4300,
      } as NotificationOptions)

      setTimeout(() => {
        this.articleIsCopied = false
      }, 5000)
    }
  }

  private goToReviews() {
    this.goTo('reviews')
  }

  private isPhotoPopup = false
  private isLoading = false

  private photoStart = 0

  private photoPopupToggle(state: boolean = false, start: number = 0) {
    this.isPhotoPopup = state
    this.photoStart = start
  }

  private kit: InterfaceProductsBlock | null = null
  private products = {
    block1: [],
    block2: [],
  }

  private get classProducts() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
      [this.$style.products]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
    }
  }

  private get classToFavouriteButton() {
    return {
      [this.$style.actionsFavourite]: true,
      [this.$style.active]: this.isInFavourites,
    }
  }

  private items = []
  private styleSpacer!: IStyle
  private aspects: IProductAspectsItem[] = []
  private aspectsForBuy: IProductToCart[] = []

  private changeLocation() {
    if (process.client) {
      window.location.reload()
    }
  }

  private JSONLDImage: string[] = []
  private JSONLDDescription: string = ''
  private vendorCode: string = ''
  private brand: IProductBrand | null = null
  private category: string = ''
  private name: string = ''
  private variant: string = ''
  private hasCredits = false

  private reviews: {
    title: string
    photosTitle: string
    rating: number
    amount: number
    canAdd?: boolean
    items: IReview[]
  } | null = null

  private get structuredDataReviews() {
    if (!this.reviews) {
      return []
    }
    if (!this.reviews.items) {
      return []
    }
    return this.reviews.items.map((item: IReview) => {
      return {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: item.rating,
          bestRating: '5',
        },
        author: {
          '@type': 'Person',
          name: item.name,
        },
        reviewBody: `${item.plus} ${item.minus} ${item.comment}`,
      }
    })
  }

  private get priceValidUntil() {
    const today = new Date()
    const plusMonth = new Date(today)
    plusMonth.setDate(plusMonth.getMonth() + 1)
    return plusMonth
  }

  private prices: IPriceItem[] = []

  private get structuredData() {
    let base = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: this.meta ? this.meta.h1 : '',
      image: this.JSONLDImage,
      description: this.JSONLDDescription,
      sku: this.vendorCode,
      brand: {
        '@type': 'Brand',
        name: this.brand ? this.brand.title : '',
      },

      offers: {
        '@type': 'Offer',
        url: this.origin + this.$route.path,
        priceCurrency: this.getOptionsCurrencyCode,
        price: this.firstPrice.final,
        priceValidUntil: this.priceValidUntil.toISOString(),
        itemCondition: 'http://schema.org/NewCondition',
        availability: this.inStock
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
      },
    }
    if (this.reviews && this.reviews.items) {
      base = Object.assign(base, {
        review: this.structuredDataReviews,
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: this.reviews.rating,
          reviewCount: this.reviews.amount,
        },
      })
    }
    return base
  }

  private head() {
    return {
      script: [
        {
          json: this.structuredData,
          type: 'application/ld+json',
        },
      ],
    }
  }

  private mounted(): void {
    window.dataLayer = window.dataLayer || []
    if (window.dataLayer) {
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'RUB',
          detail: {
            products: [
              {
                id: this.id,
                name: this.name,
                price: this.firstPrice.final,
                brand: this.brand && this.brand.title ? this.brand.title : '',
                category: this.category || '',
                variant: this.variant || '',
              },
            ],
          },
        },
      })
    }
    if (this.$route.hash === '#reviews') {
      this.goToReviews()
    }
    if (this.sectionBlocks.length > 0 && !this.$device.isMobileOrTablet) {
      setTimeout(() => {
        this.initObserverForSection()
      }, 250)
    }

    if (
      this.hasVCredit &&
      (this.hasVCredit.credit || this.hasVCredit.installment)
    ) {
      if (!window.GLOBAL_V_CREDIT_OBJECT) {
        const s = document.createElement('script')
        s.type = 'text/javascript'
        s.src = 'https://v-credit.su/services/credit/inc.js'
        s.async = true
        document.head.append(s)
      }
    }
  }

  private activeSectionMenuItem: string | null = null

  private sectionBlocks: ISectionBlock[] = []

  private initObserverForSection() {
    const that = this
    const scrollHandler = debounce(() => {
      that.maxVisiblePercentage = 0
      that.sectionBlocks.forEach((item) => {
        that.checkSection(item)
        that.activeSectionMenuItem = that.mostVisibleSectionCode
      })
    }, 50)
    this.scrollHandler = scrollHandler
    window.addEventListener('scroll', scrollHandler)
  }

  private scrollHandler: any = null
  private mostVisibleSectionCode: string | null = null
  private maxVisiblePercentage: number = 0

  private checkSection(item: ISectionBlock) {
    let sectionEl: HTMLElement | null = null
    if (this.$refs[item.code]) {
      if ((this.$refs[item.code] as Vue).$el) {
        sectionEl = (this.$refs[item.code] as Vue).$el as HTMLElement
      } else {
        sectionEl = this.$refs[item.code] as HTMLElement
      }
    }

    if (!sectionEl) return

    const rect = sectionEl.getBoundingClientRect()
    const visibleHeight =
      Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
    const visiblePercentage =
      Math.max(
        visibleHeight / window.innerHeight,
        visibleHeight / rect.height
      ) * 100
    if (
      visiblePercentage > 50 &&
      visiblePercentage > this.maxVisiblePercentage
    ) {
      this.maxVisiblePercentage = visiblePercentage
      this.mostVisibleSectionCode = item.code
    }
  }

  private hasVCredit: Record<string, boolean> | null = null

  private onEscapeKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.photoPopupToggle()
    }
  }

  private beforeDestroy() {
    window.removeEventListener('keyup', this.onEscapeKeyUp)
    window.removeEventListener('scroll', this.scrollHandler)
  }

  private beforeRouteLeave(to: Route, _: Route, next: any) {
    if (
      to.name !== 'catalog-_slug' ||
      (to.name === 'catalog-_slug' &&
        this.backFromCatalogName !== to.params._slug)
    ) {
      this.setBackFromProductName(null)
      this.setBackFromCatalogName(null)
      this.catalogSetProduct(null)
    }

    next()
  }

  private beforeRouteUpdate(_to: Route, _: Route, next: any) {
    this.setBackFromProductName(null)
    this.setBackFromCatalogName(null)
    this.catalogSetProduct(null)

    next()
  }

  private aspectsChangeQuantity(items: IProductAspectsVariant[]) {
    this.aspectsForBuy = items.map((item) => {
      return {
        id: item.id,
        quantity: item.quantityCurrent || 0,
      }
    })
  }

  private get panelFixedBottomClass() {
    return {
      [this.$style.b0]:
        (this.layoutHeaderMobileNumber === 3 ||
          this.layoutHeaderMobileNumber === 4) &&
        !this.isNativePlatform,
      [this.$style.b65]:
        this.layoutHeaderMobileNumber === 1 ||
        this.layoutHeaderMobileNumber === 2 ||
        this.isNativePlatform,
    }
  }

  private goToStores() {
    this.goTo('stores')
  }

  private get firstPrice():
    | IPriceItem
    | {
        value: number | null
        final: number | null
      } {
    return this.prices.length ? this.prices[0] : { value: null, final: null }
  }

  private hasScripts = false

  private async toCompare(product: IProductToCompare) {
    if (this.isInCompare) {
      await this.$router.push(filterUrl(COMPARE_PATH))
    } else {
      await this.toCompareAction(product)
    }
  }

  private changeAdditionalServices(event: IProductAdditionalService[]) {
    this.additionalServicesForBuy = event
  }

  private packaging: string[] = []

  private goTo(code: string) {
    if (this.$refs[code]) {
      let offset = -1 * (24 + this.getFixedHeaderHeight)
      if (this.$device.isMobileOrTablet) {
        offset = -48
      }
      offset = offset - 57
      const el = (this.$refs[code] as Vue).$el
        ? ((this.$refs[code] as Vue).$el as HTMLElement)
        : (this.$refs[code] as Vue)
      if (el) {
        ;(VueScrollTo as any).scrollTo(el, { offset, lazy: false })
      }
    }
  }

  private get getFixedHeaderClasses() {
    const isFixed =
      this.layoutHeaderNumber &&
      this.fixedHeaderNumbers.includes(this.layoutHeaderNumber)

    return {
      [this.$style.fixedHeader]: isFixed,
      [this.$style['fixedHeader__' + this.layoutHeaderNumber]]: isFixed,
    }
  }
}
